import { render } from "./Holder.vue?vue&type=template&id=624d3dc4&scoped=true&ts=true"
import script from "./Holder.vue?vue&type=script&lang=ts"
export * from "./Holder.vue?vue&type=script&lang=ts"

import "./Holder.vue?vue&type=style&index=0&id=624d3dc4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624d3dc4"]])

export default __exports__